import * as React from 'react';

import { ButtonQHDS } from '../qldDesignSystem';
import { ButtonProps } from '../qldDesignSystem/button/Button';

import styles from './card.module.scss';

const Card = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
	({ className, ...props }, ref) => (
		<div ref={ref} className={`${styles.card} ${className || ''}`} {...props} />
	),
);
Card.displayName = 'Card';

const CardHeader = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
	({ className, ...props }, ref) => (
		<div ref={ref} className={`${styles.cardHeader} ${className || ''}`} {...props} />
	),
);
CardHeader.displayName = 'CardHeader';

const CardTitle = React.forwardRef<HTMLHeadingElement, React.HTMLAttributes<HTMLHeadingElement>>(
	({ className, ...props }, ref) => (
		<h3 ref={ref} className={`${styles.cardTitle} ${className || ''}`} {...props} />
	),
);
CardTitle.displayName = 'CardTitle';

const CardDescription = React.forwardRef<
	HTMLParagraphElement,
	React.HTMLAttributes<HTMLParagraphElement>
>(({ className, ...props }, ref) => (
	<p ref={ref} className={`${styles.cardDescription} ${className || ''}`} {...props} />
));
CardDescription.displayName = 'CardDescription';

const CardContent = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
	({ className, ...props }, ref) => (
		<div ref={ref} className={`${styles.cardContent} ${className || ''}`} {...props} />
	),
);
CardContent.displayName = 'CardContent';

const CardFooter = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
	({ className, ...props }, ref) => (
		<div ref={ref} className={`${styles.cardFooter} ${className || ''}`} {...props} />
	),
);
CardFooter.displayName = 'CardFooter';

const CardAction = ({
	onClick,
	children,
	variant = 'tertiary',
	...props
}: {
	onClick: () => void;
	children: React.ReactNode;
	variant?: 'primary' | 'secondary' | 'tertiary';
} & ButtonProps) => {
	return (
		<ButtonQHDS {...props} type={variant} onClick={onClick}>
			{children}
		</ButtonQHDS>
	);
};

export { Card, CardHeader, CardFooter, CardTitle, CardDescription, CardContent, CardAction };
